import {http} from '@/services/http.js'
import {appVersion} from '@/constants/app.js'
import {useEnv} from '@/composables/use-env.js'
import {ref} from 'vue'

/**
 * Version check composable
 */
export function useVersionCheck() {

  //Local version
  const {gitHash} = useEnv()
  const interval = ref(null)
  const hasNewVersion = ref(false)

  //Check version
  const checkVersion = async () => {
    try {
      const {origin} = window.location
      const data = await http.request(`${origin}/version.json`, {
        headers: {
          'X-App-Version': appVersion,
          'X-App-Git-Hash': gitHash.value,
        },
        cache: 'no-store',
      })
      if (data?.version && data.version !== gitHash.value) {
        console.warn(`⚠️ Version mismatch\n  - Local version: ${gitHash.value}\n  - Available version: ${data.version} (${data.date})`)
        hasNewVersion.value = true
        stopVersionCheck()
      }
    }
    catch (error) {
      console.warn(`⚠️ Error checking version: ${error.message}`)
    }
  }

  //Check version every minute
  const startVersionCheck = () => {
    checkVersion()
    interval.value = setInterval(checkVersion, 60000)
  }
  const stopVersionCheck = () => clearInterval(interval.value)

  //Expose interface
  return {
    startVersionCheck,
    stopVersionCheck,
    hasNewVersion,
  }
}
